import styled from '@emotion/styled';
import { BodyMedium, BodySmall } from '../../Typography';
import { theme } from '../../../theme';

type StackedBarChartProps = {
  options: {
    label: string;
    description?: string;
    value: number;
    color: string;
  }[];
  showLegend?: boolean;
};
export const StackedBarChart = ({ options, showLegend }: StackedBarChartProps) => {
  const totalCount = options.reduce((acc, option) => acc + option.value, 0);

  return (
    <>
      {showLegend && (
        <Legend>
          {options.map((option, index) => {
            return (
              <LegendItem key={index}>
                <LegendItemIcon color={option.color}></LegendItemIcon>
                <LegendItemText>
                  <BodySmall>{option.label}</BodySmall>
                  {option.description && <BodySmall>{option.description}</BodySmall>}
                </LegendItemText>
              </LegendItem>
            );
          })}
        </Legend>
      )}

      <BarChart>
        {options.map((option, index) => {
          const percent = totalCount > 0 ? (option.value / totalCount) * 100 : 0;
          if (percent === 0) return null;
          return (
            <BarContainer key={index} width={percent}>
              <Bar color={option.color} />
              <BodyMedium bold>{percent.toFixed(0)}%</BodyMedium>
            </BarContainer>
          );
        })}
      </BarChart>
    </>
  );
};

const BarContainer = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  text-align: end;
`;

const BarChart = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.b};
  width: 100%;
`;

const Bar = styled.div<{ color: string }>`
  height: 22px;
  background-color: ${({ color }) => color};
`;

const Legend = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.g};
  padding-bottom: ${theme.spacing.g};
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${theme.spacing.d};
`;

const LegendItemIcon = styled.div<{ color: string }>`
  width: ${theme.spacing.d};
  height: ${theme.spacing.d};
  background-color: ${({ color }) => color};
  border-radius: 50%;
`;

const LegendItemText = styled.div`
  display: flex;
  flex-direction: column;
`;
